import { CircleAlert, CircleCheck, CircleHelp } from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";
import type { ResolveStatus } from "@/types/api";

interface Props {
  status: ResolveStatus;
  fromMapping?: boolean;
  className?: string;
}

export function ResolveStatusBadge({
  status,
  fromMapping,
  className,
}: Props): React.ReactElement {
  if (status === "mapped" || status === "auto") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 text-xs font-medium text-green-700",
          className,
        )}
      >
        <CircleCheck className="size-4" />
        {status === "mapped" || fromMapping
          ? "Из справочника соответствий"
          : "Найдено в 1С автоматически"}
      </span>
    );
  }
  if (status === "multiple") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 text-xs font-medium text-amber-600",
          className,
        )}
      >
        <CircleHelp className="size-4" />
        Нужно выбрать вариант
      </span>
    );
  }
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-xs font-medium text-destructive",
        className,
      )}
    >
      <CircleAlert className="size-4" />
      В 1С не найдено
    </span>
  );
}

export function statusTone(
  status: ResolveStatus,
): "green" | "amber" | "red" {
  if (status === "mapped" || status === "auto") return "green";
  if (status === "multiple") return "amber";
  return "red";
}
